<template>
    <div class="row justify-content-center mt-5 card">
        <div class="card-header text-primary">Create Beneficiary Account</div>
        <div class="col-md-8 col-sm-12 card-body offset-2">
            <div class="alert alert-info pb-0 text-center" v-if="success">
                <p>Beneficiary's <b>login details</b> was sent to {{formInfo.email}}</p>
                <p>
                    <button @click="anotherOne" class="btn btn-info btn-sm">Create another Beneficiary</button>
                </p>
            </div>
            <div class="mt-5" v-else>
                <form action="#" @submit.prevent>
                    
                    <div class="row form-group mb-3">
                        <label class="col-md-4"><span class="text-danger">*</span> Beneficiary Name</label>
                        <input class="form-control col-md-5" type="text" placeholder="Enter Beneficiary name" v-model.trim="$v.formInfo.name.$model"  :class="{'is-invalid':$v.formInfo.name.$error, 'is-valid':!$v.formInfo.name.$invalid}">
                    </div>

                    <div class="row form-group mb-3">
                        <label class="col-md-4"><span class="text-danger">*</span>Beneficiary Email</label>
                        <input class="form-control col-md-5" type="email" placeholder="Enter Beneficiary Email" v-model.trim="$v.formInfo.email.$model"  :class="{'is-invalid':$v.formInfo.email.$error, 'is-valid':!$v.formInfo.email.$invalid}">
                    </div>

                    <div class="row form-group mb-3">
                        <label class="col-md-4"><span class="text-danger">*</span>Beneficiary Phone Number</label>
                        <input class="form-control col-md-5" type="text"  placeholder="Enter Beneficiary phone" v-model.trim="$v.formInfo.phone.$model"  :class="{'is-invalid':$v.formInfo.phone.$error, 'is-valid':!$v.formInfo.phone.$invalid}">
                    </div>
                 
                    <div class="row form-group mb-3 mt-4">
                        <label class="col-md-4"></label>
                        <button v-if="!sending" class="btn btn-primary btn-sm col-md-5" :disabled="$v.formInfo.$invalid || hasVoted == 'true'" type="submit" @click.prevent="createBeneficiary()"> Create Beneficiary </button>
                        
                        <button v-else class="btn btn-primary btn-sm col-md-5" disabled type="submit" > Create Beneficiary </button>
                    </div>

                </form>
            </div>
        </div> <!-- end col -->
    </div>
</template>

<script>
import { required, email, minLength} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
export default {
    name: "CreateBeneficiary",
    data(){
        return {
            formInfo: {
                email: null,
                phone: null,
                name: null,
            },
            sending:false,
            hasVoted:false,
            success:false,

        }
    },
    validations: {
        formInfo: {
            email: { required, email },
            phone:{ required, minLength: minLength(9) },
            name:{ required },
        }
    },

    computed:{
        ...mapState(['token'])
    },

    methods:{
        anotherOne(){
            this.success = !this.success;
            this.formInfo.email = null;
            this.formInfo.phone = null;
            this.formInfo.name = null;
        },
        createBeneficiary(){
            // Only send after validations
            this.$v.formInfo.$touch()
            if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
                this.$toastr.e("Fill in the forms correctly");
            } else {
                // submit logic
                const baseU = `${this.$urlAuth}/beneficiary/create`;

                this.$http.post(baseU, this.formInfo, {
                    headers:{
                        "x-access-token":this.token
                    }
                })
                .then((result) => {
                    if(result.data.data.code == "S201"){
                        console.log(result);
                        this.$toastr.s("Account Created Succesfully");

                        this.success = true;

                    }else if(result.data.data.code == "E301"){
                        this.$toastr.e(result.data.data.message[0], 'Error message');
                    }else if(result.data.data.code == "E200"){
                        this.$toastr.e(result.data.data.message, 'Error message');
                    }else{
                        this.$toastr.e("Unexpected Error. Please contact Admin");
                    }
                }).catch(err =>{
                    console.log(err);
                    this.$toastr.e("Internal server error");
                })
            }
        }
    }
}
</script>
